<template>
  <v-row>
    <v-col
      cols="12"
      sm="6"
      md="6"
    >
      <v-data-table
        :headers="headers"
        :items="ParamsDI"
        :items-per-page="5"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              Paramètre domaine d'intervention
            </v-toolbar-title>
            <v-spacer />
            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <template v-slot:activator="{ on, attrs}">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Nouveau
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-text-field
                          v-model="ParamDIEdit.libelle_parametrage_domaine_interventions"
                          label="Libellé"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darke-1"
                    @click="close"
                  >
                    Fermer
                  </v-btn>
                  <v-btn
                    color="blue darke-1"
                    @click="saveParamDI"
                  >
                    Enregistrer
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogDelete"
              max-width="500px"
            >
              <v-card>
                <v-card-title class="text-h5">
                  Are you sure you want to delete this item?
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeDelete"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="deleteItemConfirm"
                  >
                    OK
                  </v-btn>
                  <v-spacer />
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.actions="{item}">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
          <v-icon
            small
            @click="navigateTo(item)"
          >
            mdi-tune-variant
          </v-icon>
        </template>
        <template v-slot:item.logo_organisations="{item}">
          <v-img
            :lazy-src="item.logo_organisations"
            max-height="150"
            max-width="250"
            :src="item.logo_organisations"
          />
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import paramettres from '@/services/parametre-domaine-intervention.js'
  export default {
    data () {
      return {
        dialog: false,
        dialogDelete: false,
        headers: [
          { text: 'Actions', value: 'actions', sortable: false },
          {
            text: 'Libellé',
            value: 'libelle_parametrage_domaine_interventions',
          },
        ],
        ParamsDI: [],
        editedIndex: -1,
        ParamDIEdit: {
          id: '',
          libelle_parametrage_domaine_interventions: '',
        },
        ParamDI: {
          libelle_parametrage_domaine_interventions: '',
        },
      }
    },
    mounted () {
      console.log(this.editedIndex)
      paramettres.getParamsDI().then(response => {
        this.ParamsDI = response.data
      })
    },
    computed: {
      ...mapGetters(['getThemeMode']),
      formTitle () {
        return this.editedIndex === -1 ? 'Ajouter un paramètre' : 'Modifier un paramètre'
      },
    },
    methods: {
      ...mapActions(['changeThemeLayout']),
      saveParamDI () {
        if (this.editedIndex > -1) {
          paramettres.updateParamsDI(this.ParamDIEdit).then(response => {
            console.log(response.data)
            paramettres.getParamsDI().then(response => {
              this.ParamsDI = response.data
            })
            this.dialog = false
          }).catch(err => {
            console.log(err.response.data)
          })
        } else {
          paramettres.createParamsDI(this.ParamDIEdit).then(response => {
            console.log(response.data)
            paramettres.getParamsDI().then(response => {
              this.ParamsDI = response.data
            })
            this.dialog = false
          }).catch(err => {
            console.log(err.response.data)
          })
        }
        this.close()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.ParamDIEdit = Object.assign({}, this.ParamDI)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.editedIndex = this.ParamsDI.indexOf(item)
        this.ParamDIEdit = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.ParamsDI.indexOf(item)
        this.ParamDIEdit = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        paramettres.deleteParamsDI(this.ParamDIEdit).then(response => {
          paramettres.getParamsDI().then(response => {
            this.ParamsDI = response.data
          })
        }).catch(err => {
          console.log(err.response.data)
        })
        this.closeDelete()
      },
      navigateTo (item) {
        this.$router.push({
          name: 'ligne-domaine-intervention.index',
          params: { DI: item.id },
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.ParamDIEdit = Object.assign({}, this.ParamDI)
          this.editedIndex = -1
        })
      },
    },
  }
</script>

<style scoped>

</style>
